exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".no-documents-text{color:#31708f !important}.no-documents-icon{padding-bottom:13px}.choose-document-btn{color:#333f !important}.choose-document-input{display:none !important}.document-image{color:gray}.document-pdf{color:lightcoral}.document-upload-input{height:42px}.document-queue{padding-bottom:10px}.document-queue-element{margin-right:5px;color:white !important;font-family:monospace}.document-upload-progress{margin-top:1rem;margin-bottom:1rem;background-color:#393e46}.documents-queue-container{padding-bottom:10px;display:flex;flex-wrap:wrap}.documents-upload-btn{margin-left:0px}\n", ""]);

// exports
